import { 
    CreateQuoteTransportDto, 
    DeleteQuoteTransportDto,
    EditQuoteTransportDto,
    GetQuoteTransportDto, 
    MessageResponseDto, 
    QuoteTransportApiFp,
    QuoteTransportControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseQuoteTransportModel = QuoteTransportControllerGet200Response;
export type GetQuoteTransportModel = GetQuoteTransportDto;
export type MutateResponseQuoteTransportModel = MessageResponseDto;
export type CreateQuoteTransportModel = CreateQuoteTransportDto;
export type UpdateQuoteTransportModel = EditQuoteTransportDto;
export type DeleteQuoteTransportModel = DeleteQuoteTransportDto;

export const apiQuoteTransportFp = QuoteTransportApiFp(apiConfig);
export const getQuoteTransportController = apiQuoteTransportFp.quoteTransportControllerGet;
export const createQuoteTransportController = apiQuoteTransportFp.quoteTransportControllerCreate;
export const updateQuoteTransportController = apiQuoteTransportFp.quoteTransportControllerEdit;
export const deleteQuoteTransportController = apiQuoteTransportFp.quoteTransportControllerDelete;

export const QueryKeyQuoteTransport = QueryKey.QuoteTransport;